export default {
  title: 'Analytics',
  description: 'Suivez les performances et les statistiques',
  overview: 'Vue d\'ensemble',
  coverage: {
    title: 'Couverture',
    description: 'Vue d\'ensemble des performances de votre contenu et de l\'engagement du public'
  },
  errors: {
    loadFailed: 'Échec du chargement des statistiques de couverture'
  },
  period: {
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    thisMonth: 'Ce mois-ci',
    lastMonth: 'Le mois dernier',
    custom: 'Période personnalisée'
  },
  dateRange: 'Période',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  quickShortcuts: 'Raccourcis rapides',
  shortcuts: {
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    thisMonth: 'Ce mois-ci',
    lastMonth: 'Mois dernier',
    thisYear: 'Cette année',
    lastYear: 'Année dernière'
  },
  metrics: {
    impressions: {
      label: 'Impressions',
      description: 'Nombre de fois où votre contenu a été affiché aux utilisateurs'
    },
    views: {
      label: 'Vues',
      description: 'Nombre de fois où votre contenu a été réellement lu ou visionné'
    },
    uniqueViewers: {
      label: 'Spectateurs uniques',
      description: 'Nombre d\'utilisateurs distincts ayant visionné votre contenu'
    },
    avgViewDuration: {
      label: 'Durée moy. de visionnage',
      description: 'Temps moyen passé à visionner votre contenu par session'
    },
    totalWatchTime: {
      label: 'Temps de visionnage total',
      description: 'Temps total cumulé passé à visionner l\'ensemble de votre contenu'
    },
    clickThroughRate: {
      label: 'Taux de clic',
      description: 'Pourcentage d\'impressions ayant abouti à des vues (Vues / Impressions)'
    },
    avgCompletionRate: {
      label: 'Taux de complétion moy.',
      description: 'Pourcentage moyen du contenu visionné avant que les utilisateurs arrêtent'
    },
    assetsCount: {
      label: 'Médias',
      description: 'Nombre de fichiers médias inclus dans ces statistiques'
    },
    growth: 'Croissance',
    sessions: 'Sessions',
    bounceRate: 'Taux de rebond',
    pagesPerSession: 'Pages par session',
    newUsersPercentage: 'Nouveaux utilisateurs'
  },
  granularity: {
    hour: 'Heure',
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois'
  },
  charts: {
    timeSeries: 'Vues et impressions',
    uniqueViewersOverTime: 'Spectateurs uniques',
    watchTimeOverTime: 'Temps de visionnage',
    deviceDistribution: 'Répartition par appareil',
    worldHeatmap: 'Distribution géographique',
    topAssets: 'Top des assets',
    topCountries: 'Top des pays',
    topReferrers: 'Top des référents',
    topTags: 'Top des tags'
  },
  origin: {
    worldHeatmap: {
      title: 'Vues par pays'
    }
  },
  geography: {
    title: 'Analyse géographique',
    description: 'Découvrez d\'où vient votre audience et suivez les tendances géographiques',
    topCountries: 'Top des pays',
    views: 'vues',
    regionalDistribution: 'Répartition régionale',
    topCities: 'Top des villes',
    totalCountries: 'Total des pays',
    topCountry: 'Premier pays',
    topRegion: 'Première région',
    avgViewsPerCountry: 'Vues moy. par pays',
    country: 'Pays',
    percentage: 'Part',
    growth: 'Croissance',
    viewAll: 'Voir tout',
    totalCountriesDesc: 'Nombre de pays visualisant votre contenu',
    ofTotalViews: 'du total des vues',
    avgViewsPerCountryDesc: 'Nombre moyen de vues par pays'
  },
  trafficSources: {
    title: 'Sources de trafic',
    description: 'Comprenez comment les visiteurs trouvent et interagissent avec votre contenu',
    overview: 'Aperçu du trafic',
    sessions: 'sessions',
    totalSessions: 'Sessions totales',
    avgSessionDuration: 'Durée moy. de session',
    avgBounceRate: 'Taux de rebond moy.',
    topSource: 'Source principale',
    insights: 'Insights clés',
    topReferrers: 'Top des référents',
    referrer: 'Référent',
    views: 'Vues',
    bounceRate: 'Taux de rebond',
    avgDuration: 'Durée moy.',
    socialMedia: 'Performance des réseaux sociaux',
    searchEngines: 'Moteurs de recherche',
    campaigns: 'Performance des campagnes UTM',
    campaignInfo: 'Suivez les performances de vos campagnes marketing avec les paramètres UTM',
    campaign: 'Campagne',
    source: 'Source',
    clicks: 'Clics',
    conversions: 'Conversions',
    conversionRate: 'Taux de conversion',
    exportData: 'Exporter les données',
    utmTracking: 'Suivi UTM'
  },
  filters: {
    title: 'Filtres',
    apply: 'Appliquer les filtres',
    clear: 'Tout effacer',
    dateRange: 'Période',
    devices: 'Appareils',
    countries: 'Pays',
    referrers: 'Référents',
    tags: 'Tags'
  },
  reviews: {
    title: 'Avis',
    description: 'Feedback et évaluations de vos spectateurs',
    basedOn: 'Basé sur {count} avis',
    sortBy: 'Trier par',
    allRatings: 'Toutes les notes',
    export: 'Exporter',
    comments: 'Commentaires',
    helpful: 'Utile',
    reply: 'Répondre',
    noReviews: 'Aucun avis pour le moment',
    noReviewsDesc: 'Les avis apparaîtront ici une fois que les spectateurs commenceront à évaluer votre contenu',
    mostRecent: 'Plus récents',
    oldest: 'Plus anciens',
    ratingAsc: 'Note croissante',
    ratingDesc: 'Note décroissante',
    assetsReviewed: 'Assets évalués',
    avgReviewsPerAsset: '{avg} avis par asset',
    avgRating: 'Note moyenne',
    avgRatingDesc: 'Note moyenne sur tous les avis',
    totalReviews: 'Total des avis',
    totalReviewsDesc: 'Nombre total d\'avis reçus',
    assetsReviewedDesc: 'Nombre d\'assets uniques avec des avis',
    reviewsPerAsset: 'Avis par asset',
    reviewsPerAssetDesc: 'Nombre moyen d\'avis par asset',
    ratingBreakdown: 'Répartition des notes',
    reviews: 'avis'
  },
  export: {
    title: 'Exporter les données',
    format: 'Format',
    button: 'Exporter',
    excel: 'Excel (.xlsx)',
    csv: 'CSV (.csv)',
    download: 'Télécharger le rapport'
  },
  noData: 'Aucune donnée disponible pour la période sélectionnée',
  loading: 'Chargement des données analytics...',
  error: 'Échec du chargement des données analytics'
}
